import { useState, useEffect } from "react";
import ApiService from "../../service/ApiService";
import { apiPaths } from "../../service/apiPaths";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const useBanner = () => {
  const [bannerData, setBannerData] = useState<any[]>([]);
  const [selectedBannerView, setSelectedBannerView] = useState<
    string | null
  >(null);
  const [selectedBannerId, setSelectedBannerId] = useState<string | null>(
    null
  );
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const result = await ApiService({
        method: "GET",
        endpoint: apiPaths.getBanner,
      });
      setBannerData(result);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const formatDateToISODateString = (date: Date): string => {
    return date.toISOString().split("T")[0];
  };

  const handleDateFilter = async (fromDate: Date, toDate: Date) => {
    const formattedFromDate = formatDateToISODateString(fromDate);
    const formattedToDate = formatDateToISODateString(toDate);

    try {
      const result = await ApiService({
        method: "GET",
        endpoint: `${apiPaths.getStandard}?fromDate=${formattedFromDate}&toDate=${formattedToDate}`,
      });
      setBannerData(result);
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    }
  };

  const handleView = (id: string) => {
    setSelectedBannerView(id);
  };

  const handleEdit = (id: string) => {
    setSelectedBannerId(id);
  };

  const handleDelete = async (id: string) => {
    setLoading(true);
    try {
      await ApiService({
        method: "DELETE",
        endpoint: `${apiPaths.deleteBanner}/${id}`,
      });
      setBannerData((prevData) =>
        prevData.filter((banner) => banner._id !== id)
      );
      toast.success("Banner deleted successfully");
    } catch (error) {
      console.error("Error deleting banner:", error);
      toast.error("Error deleting banner");
    } finally {
      setLoading(false);
    }
  };

  const handleStatusUp = async (id: string, currentStatus: boolean) => {
    setLoading(true);
    const newStatus = currentStatus;
    console.log(newStatus);
    try {
      await ApiService({
        method: "PUT",
        endpoint: `${apiPaths.updateBanner}/${id}`,
        data: { isActive: newStatus },
      });
      setBannerData((prevData) =>
        prevData.map((banner) =>
          banner._id === id ? { ...banner, isActive: newStatus } : banner
        )
      );
    } catch (error) {
      console.error("Error updating banner status:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = () => {
    navigate("/add-banner");
  };
  return {
    selectedBannerView,
    selectedBannerId,
    bannerData,
    loading,
    handleView,
    handleEdit,
    handleDelete,
    handleStatusUp,
    handleDateFilter,
    handleAdd,
  };
};

export default useBanner;
